import React from 'react'
import { FiHome } from 'react-icons/fi'
import GoHome from '../../../../../components/GoHome'

function Home({ className, size = 1 }) {
  return (
    <GoHome
      size={size}
      className={className}
      center={true}
      to="/booking/calendar"
    >
      <FiHome size={21 * size} />
    </GoHome>
  )
}

export default Home
